import { MyIcon } from 'ccs-ui-components';
import { Accordion } from 'react-bootstrap';

import NestedSummary from './NestedSummary';
import SummaryGrid from './SummaryGrid';
import { CircleBadgeProps, ConfigDetailType, ConfigType, ImportedJourneySummaryProps } from './utility/TypeDefs';

import classes from './ImportedJourneySummary.module.scss';

/**
 * @description Component to create circle badge
 * @param {CircleBadgeProps} prop - CircleBadgeProps.
 */
const CircleBadge = ({ count }: CircleBadgeProps) => (
  <div className={classes['cp-circle-badge']} data-testid="sr-counter-badge">
    <div className={classes['cp-circle-badge-text']}>
      {count}
    </div>
  </div>
);

const ImportedJourneySummary = ({ records }: ImportedJourneySummaryProps) => {
  /**
  * @method renderSummary
  * @description Renders appropriate summary component based on whether details has nested values or not.
  * @param {ConfigDetailType[]} details - Config details
  * @param {string} configType - Config type
  */
  const renderSummary = (details: ConfigDetailType[], configType: string) => {
    const isNested = details.some((detail: ConfigDetailType) => detail.records);
    if (isNested) {
      return <NestedSummary gridData={details} />;
    }
    return <SummaryGrid gridData={details} recordType={configType} />;
  };
  return (
    <div className={classes['summary-container']}>
      {
        records?.map((config: ConfigType, index: number) => (
          <Accordion flush key={`summary_accordion_${config?.recordType}`} defaultActiveKey={index === 0 ? `acc_${config?.recordType}` : ''}>
            <Accordion.Item eventKey={`acc_${config?.recordType}`}>
              <Accordion.Header>
                <div>
                  <span><MyIcon name="bottonArrowIcon" className="summary-arrow-icon" /></span>
                  <span className={classes['config-type-text']}>{config?.recordType}</span>
                  {
                    !!config?.recordsCount
                    && (
                      <span><CircleBadge
                        count={`${config?.recordsCount}`}
                      />
                      </span>
                    )
                  }
                </div>
              </Accordion.Header>
              <Accordion.Body>
                {
                  renderSummary(config?.exportImportRecordDetails, config?.recordType)
                }
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        ))
      }
    </div>
  );
};

export default ImportedJourneySummary;
